import React from 'react';
import {
  Datagrid,
  DateField,
  List,
  TextField,
  ReferenceField,
  useTranslate,
} from 'react-admin';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import {
  NumberWithUnitField,
  DownloadInvoiceButton,
  InvoiceStatusChipField,
} from '../../components';

import Expand from './shared/Expand';
import Filter from './details/Filter';

const InvoiceList = (props) => {
  const translate = useTranslate();
  useDocumentTitle(
    translate('app.page_title.list', {
      resource: translate('resources.invoice.name', { smart_count: 2 }),
    }),
  );
  return (
    <List
      {...props}
      filters={<Filter />}
      filterDefaultValues={{ status: 'CLOSED' }}
      sort={{ field: 'due_date', order: 'DESC' }}
      bulkActionButtons={false}
      perPage={25}
    >
      <Datagrid rowClick="edit" expand={<Expand />}>
        <TextField source="invoice_number" />
        <ReferenceField
          allowEmpty
          link="show"
          source="account_id"
          reference="account"
          label="Compte"
        >
          <TextField source="name" />
        </ReferenceField>
        <DateField source="due_date" />
        <NumberWithUnitField unit="€" source="amount" />
        <NumberWithUnitField unit="€" source="total_tax" />
        <NumberWithUnitField unit="€" source="total_amount" />
        <InvoiceStatusChipField source="status" />
        <DownloadInvoiceButton label="" variant="icon" />
      </Datagrid>
    </List>
  );
};

export default InvoiceList;
